export default "__VITE_ASSET__C$3Qp15m__"